(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-card-slider"] && !Shopify.designMode) return;
  try {
    
$('.custom-slick-slider .slider-wrapper').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  appendDots: $('.custom-slick-slider .slick-dots-wrapper'),
  prevArrow: $('.custom-slick-slider .slick-prev'),
  nextArrow: $('.custom-slick-slider .slick-next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
